import { BehaviorSubject, Observable } from 'rxjs';
import { filter, share, switchMap } from 'rxjs/operators';
import { ChannelInfo, name } from './channels';
import { client } from './client';
import { EventType, SocketData } from './models';
import { Subscriptions } from './subscriptions';

const subscriptions = new BehaviorSubject(Subscriptions.empty());
const subs = () => subscriptions.value;

export const pushes = <T>(
  info: ChannelInfo,
  [action, type]: EventType,
): Observable<SocketData<T>> =>
  client().pipe(
    switchMap(
      (pusher) =>
        new Observable<SocketData<T>>((subscriber) => {
          const channel_name = name(info);
          const channel = pusher.subscribe(channel_name);
          const handler = subscriber.next.bind(subscriber);

          channel.bind(action, handler);
          subscriptions.next(Subscriptions.add(subs(), channel_name));

          return () => {
            channel.unbind(action, handler);
            subscriptions.next(Subscriptions.remove(subs(), channel_name));
            if (Subscriptions.has_none(subs(), channel_name)) {
              pusher.unsubscribe(channel_name);
            }
          };
        }),
    ),
    filter(({ objectType }) => objectType === type),
    share(),
  );
